<template>
  <drag-dialog
    title="地图名称"
    :width="400"
    :visible.sync="visible"
    :defaultTop="320"
    :defaultLeft="800"
    :footerBtn="['cancel', 'submit']"
    :submit="submit"
    :cancel="cancel"
  >
    <el-form
      :model="form"
      class="form public-form-primary"
      label-width="100px"
      :rules="rules"
      ref="form"
    >
      <el-form-item class="form-item" label="地图名称:" prop="serviceName">
        <el-input
        class="input-primary"
          :maxlength="20"
          show-word-limit
          v-model="form.serviceName"
          placeholder="请输入地图名称"
        ></el-input>
      </el-form-item>
    </el-form>
  </drag-dialog>
</template>
  
  <script>
import dragDialog from "@/components/DragDialog.vue";
export default {
  data() {
    const validServiceNameRule = (rule, value, callback) => {
      if (value.length === value.trimStart().trimEnd().length) {
        return callback();
      } else {
        callback(new Error("开头和结尾不允许有空格"));
      }
    };
    return {
      disabled: false,
      form: {
        serviceName: "",
      },
      rules: {
        serviceName: [
          {
            required: true,
            message: "请输入地图名称",
            trigger: "blur",
          },
          // {
          //   pattern:
          //     /^[\u4e00-\u9fa5_a-zA-Z0-9_\@_\#_\&_\*_\%_\(_\)_\（_\）_\/_\._\-_\\__\[_\]_\s_]*$/g,
          //   message: "只允许汉字,数字,字母,空格和@ # & * %（）/ . - _",
          //   trigger: "change",
          // },
          { validator: validServiceNameRule },
        ],
      },
    };
  },
  props: {
    visible: Boolean,
    serviceName: String,
    submitConfig: Function,
    closeDialog: Function,
  },
  components: {
    dragDialog,
  },
  mounted() {
    this.form.serviceName = this.serviceName;
  },
  methods: {
    submit() {
      let startInterval = setInterval(() => {
        this.disabled = false;
        clearInterval(startInterval);
      }, 60000);

      if (!this.disabled) {
        this.$refs.form.validate((bool, object) => {
          if (bool) {
            let paramsInfo = {
              serviceName: this.form.serviceName,
            };
            this.submitConfig(paramsInfo).then((response) => {
              if (response.isSuccess) {
                this.disabled = false;
                this.clearForm();
                this.closeDialog();
              } else {
                this.disabled = false;
                this.$message.error(response.errMsg);
              }
            });
          } else {
            this.$message.error("表单验证失败，请正确填写相关内容后再重新提交");
            this.disabled = false;
          }
          this.disabled = true;
        });
      }
    },
    cancel() {
      this.clearForm();
      this.closeDialog();
    },
    clearForm() {
      this.form = {
        serviceName: "",
      };
    },
  },
};
</script>
  
<style lang="less" scoped>
@import "@/assets/css/publishSearch.less";
.form {
  padding: 5px 0px;
  .form-item {
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0px;
    }
  }
}
</style>